import { type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './header/Header';
import { Sidebar } from './sidebar/Sidebar';

interface LayoutProps {
  headerTimerSlot?: ReactNode;
}

export function Layout({ headerTimerSlot }: LayoutProps) {
  return (
    <div className="h-screen flex flex-col overflow-hidden bg-background">
      {/* Header fijo — h-14 = 56px */}
      <Header timerSlot={headerTimerSlot} />

      {/* Cuerpo debajo del header */}
      <div className="flex min-h-0 flex-1 overflow-hidden pt-14">
        {/* Sidebar */}
        <Sidebar />

        {/* Contenido principal */}
        <main className="flex-1 overflow-y-auto bg-muted/40 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
// ```

// ---

// ## Por qué `pt-14` en el contenedor y no `mt-14` en el body

// El header es `fixed`, lo que lo saca del flujo normal del documento. El `pt-14` en el contenedor empuja el contenido hacia abajo exactamente el alto del header sin afectar el sidebar. Con `mt-14` directo en el body el sidebar también bajaba, pero como el `<aside>` del Sidebar ya tiene `top-14` en mobile y `relative` en desktop, el `pt-14` en el contenedor padre es suficiente y más limpio.

// ---

// ## Cómo queda el árbol visual
// ```
// {/* <div h-screen flex flex-col>
//   <Header />                    ← fixed, z-50
//   <div flex flex-1 pt-14>
//     <Sidebar />                 ← fixed en mobile, relative en desktop
//     <main flex-1 overflow-y>
//       <Outlet />                ← contenido de cada ruta
//     </main>
//   </div>
// </div> */}
